module.exports = __webpack_public_path__ + "12bef753d6ce02d2717fcc4531b063c6.svg";